module.exports = "/_next/static/images/icon7-d6bce7f6470ecc23da17bd051a024161.png";